<template>
	<div class="reviewTaskManage  mw1340">
		<el-header class="breadCrumbs">
			<el-breadcrumb separator="/">
				<i class="iconfont icon-home fl mr10"></i>
				<el-breadcrumb-item >智能审查</el-breadcrumb-item>
				<el-breadcrumb-item>审查报告管理</el-breadcrumb-item>
			</el-breadcrumb>
		</el-header>
		<el-header class="switch">
			<div class="switchCon clearfix">
				<!-- <changeFontSize></changeFontSize> -->
				<div class="operation fr mr35">
					<a class="new f_transition" @click="searchTable">
						<i class="iconfont icon-chaxun1"></i>
						查询
					</a>
					<a class="new f_transition" @click="resetFun">
						<i class="iconfont icon-zhongzhi"></i>
						重置查询条件
					</a>
               <a class="new f_transition" @click="editReviewTitleFun">
						<i class="iconfont icon-bianji1"></i>
						编辑
					</a>					
					<a class="new f_transition" @click="deleteFun">
						<i class="iconfont icon-shanchu1"></i>
						删除
					</a>
				</div>
			</div>
		</el-header>
		<el-container>
			<el-main class="reviewTaskManageMain-wrap">
				<div class="reviewTaskManageMain mt6 shadowlaw">
					<div class="filter">
						<el-form
							ref="form"
							:model="form"
							label-width="80px"
							class="clearfix"
						>
							<el-form-item label="审查类型">
								<el-select
									v-model="form.type"
									placeholder="请选择"
									:popper-append-to-body="false"
								>
									<el-option
										v-for="item in typeOptions"
										:key="item.code"
										:label="item.brief"
										:value="item.code"
									>
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="审查进度">
								<el-select
									v-model="form.process"
									placeholder="请选择"
								>
									<el-option
										v-for="item in processOptions"
										:key="item.code"
										:label="item.brief"
										:value="item.code"
									>
									</el-option>
								</el-select>
							</el-form-item>
                     <el-form-item label="审查原文">
								<el-input
                    :maxlength=1000
									v-model.trim="form.yw"
								></el-input>
							</el-form-item>
							<el-form-item label="标题">
								<el-input
                    :maxlength=200
									v-model.trim="form.title__contains"
								></el-input>
							</el-form-item>
							<el-form-item label="创建人">
								<el-input
                    :maxlength=200
									v-model.trim="form.author_name__contains"
								></el-input>
							</el-form-item>
							<el-form-item label="创建时间">
								<el-date-picker
									v-model="form.time"
									type="daterange"
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									value-format="yyyy-MM-dd"
								></el-date-picker>
							</el-form-item>
						</el-form>
					</div>
					<div class="tableBox tableBoxReviewTaskManage">
						<el-table
							ref="multipleTable"
							:data="tableData"
							tooltip-effect="dark"
							style="width: 100%"
							@selection-change="handleSelectionChange"
							v-loading="loading"
						>
							<el-table-column type="selection" width="66">
							</el-table-column>
							<el-table-column
								prop="title"
								label="标题"
								min-width="40%"
								:show-overflow-tooltip="true"
							>
								<template slot-scope="scope">
									<span @click="titleFun(scope.row.id)">{{scope.row.title}}</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="item_uuid__type__brief"
								label="审查类型"
								min-width="20%"
								:show-overflow-tooltip="true"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="process"
								label="审查进度"
								min-width="20%"
								:show-overflow-tooltip="true"
								align="center"
							>
								<template slot-scope="scope">
									第{{scope.row.process}}轮
								</template>
							</el-table-column>
							<el-table-column
								prop="item_uuid__title"
								label="审查原文"
								min-width="20%"
								:show-overflow-tooltip="true"
								align="center"
							>
							</el-table-column>
                     <el-table-column
								prop="author_department"
								label="部门"
								min-width="20%"
								:show-overflow-tooltip="true"
								align="center"
							>
							</el-table-column>
                     <el-table-column
								prop="author_name"
								label="创建人"
								min-width="20%"
								:show-overflow-tooltip="true"
								align="center"
							>
							</el-table-column>
							<el-table-column
								label="创建时间"
								min-width="20%"
								:show-overflow-tooltip="true"
								align="center"
							>
								<template slot-scope="scope">
									{{
									handleTime(scope.row.create_time)
								}}</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="page pt15 pb15 clearfix">
						<el-pagination
							@size-change="handleSizeChangeDeclare"
							@current-change="handleCurrentChangeDeclare"
							:current-page.sync="currentPageDeclare"
							:page-size="pageSize"
							background
							layout="total ,prev, pager, next, jumper"
							:total="total"
						></el-pagination>
					</div>
				</div>
			</el-main>
		</el-container>
		<!-- 编辑标题 -->
		<editTitle ref="editTitle" @parentFun="tableFun(currentPageDeclare)"></editTitle>
	</div>
</template>
<script>
//修改字号
// import changeFontSize from "../../changeFontSize.vue";
//编辑标题
import editTitle from "./editTitle.vue";
export default {
    components: {
		// changeFontSize,
		editTitle
	},
	data() {
		return {
         //筛选条件start==
			typeOptions: [//审查类型
				{					
					code: "null",
					brief: "全部",
				}
			],
			processOptions: [ //审查进度
				{
					code:1,
					brief:"第1轮"
				}
			],//审查进度
			form: {
				type: "null", //审查类型
            process:"", //审查进度
            yw:"",//原文
				title__contains: "", //标题
				author_name__contains: "", //创建人
				time: [], //时间
			},
			//筛选条件end==

			//表格start==
			loading:false,//加载中
			tableData: [
            // {
            //    title:'标题',
            //    type__brief:"整篇审查",
            //    process__brief:"第二轮",
            //    yw:"云南艾滋病防止条例",
            //    bm:"立法一处",
            //    author:"审核人A",
            //    create_time:"2021-6-29 10:46"               
            // }
         ],
			multipleSelection:[],//表格选中数据
			//表格end==

			//分页start==
			currentPageDeclare: 1, //当前页
			total: 0, // 总共条数
			pageSize: 10, //每页的数量
			//分页end==
        };
    },
    created() {
		this.tableFun(1);
		this.typeDataFun();//审查类型

		//审查进度 数字 从0-100
		// for(let i=0;i<101;i++){
		// 	let obj={
		// 		brief:i,
		// 		code:i
		// 	}
		// 	this.processOptions.push(obj)
		// }
    },
    methods: {
      //表格选中数据
		handleSelectionChange(val) {
        this.multipleSelection = val;
		},
		//分页
		handleSizeChangeDeclare(size) {
			// console.log(`每页 ${size} 条`);
			this.pageSize = size;
			this.tableFun(this.currentPageDeclare);
		},
		handleCurrentChangeDeclare(currentPage) {
			// console.log(`当前页: ${currentPage}`);
			this.currentPageDeclare = currentPage;
			this.tableFun(this.currentPageDeclare);
		},
		//将时间中的T换成空格 去掉时分秒之后的
		handleTime(t){
			t=t.replace(new RegExp(/(T)/g), '\u00a0');
			return t;
		},

		//重置
		resetFun(){			
			this.form.type= "null"; //审查类型
			this.form.process= ""; //审查进度
			this.form.yw= ""; //审查原文
			this.form.title__contains= ""; //标题
			this.form.author_name__contains= ""; //创建人
			this.form.time= []; //时间
			this.currentPageDeclare=1;
			this.tableFun(1);
      },
      //编辑审查
		editReviewTitleFun(){
			if(this.multipleSelection.length==1){
				let title=this.multipleSelection[0].title;//标题
				let id=this.multipleSelection[0].id;//要修改的报告id
				console.log(title);
				this.$refs.editTitle.childFun(title,id);
			}else if(this.multipleSelection.length>1){
				this.$message({
					message: "请选择一条数据进行编辑！",
					type: "warning",
					duration: 3000
				});
			}else{
				this.$message({
					message: `请先在列表中选中一条要编辑的智能审查任务数据，再进行编辑操作！`,
					type: "warning",
					duration: 4000
				});
			}
		},
		//删除
		deleteFun(){
			if(this.multipleSelection.length>=1){
				this.$confirm('请确认是否删除列表中已选中的智能审查报告数据？', "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					closeOnClickModal:false  //是否可通过点击遮罩关闭MessageBox
				}).then(() => { //确定
					// let id=this.multipleSelection[0].id;
					let idStr="";
					this.multipleSelection.forEach(item=>{
						idStr+=item.id+',';
					});
					idStr=idStr.substring(0,idStr.length-1);//删除最后一个字符,
					console.log('删除uuid',idStr);
					this.axios({
						method:'delete',
						url:"/japi/check/report_handle/",
						data:{
							id:idStr
						}
					}).then(res =>{
						if (res.data.code == 200) {
							console.log("删除报告成功======");
							console.log(res);
							this.$message({
								message: "删除报告成功",
								type: "success",
								duration: 3000
							});
							this.tableFun(this.currentPageDeclare);//获取数据				
							
						} else if(res.data.code == 500){
							this.$message({
								message: res.data.msg,
								type: "warning",
								duration: 3000
							});
						}
						else{
							this.$message({
								message: res.data.msg,
								type: "warning",
								duration: 3000
							});
						}
					});	
				}).catch(()=>{ //不加catch会报错
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
			// else if(this.multipleSelection.length>1){
			// 	this.$message({
			// 		message: "请选择一条数据进行删除！",
			// 		type: "warning",
			// 		duration: 3000
			// 	});
			// }
			else{
				this.$message({
					message: "请先在列表中选择要删除的智能审查报告数据，再进行删除操作。",
					type: "warning",
					duration: 3000
				});
			}
		},
		//域内检索
		searchTable() {
			this.currentPageDeclare=1;
			this.tableFun(1);
		},
		//获取table中的数据
		tableFun(str) {
			this.loading=true;//加载中显示
			let startTime="";
			let endTime="";
			if(this.form.time&&this.form.time.length>0){
				startTime=this.form.time[0];
				endTime=this.form.time[1];
			}else{
				startTime="";
				endTime="";
			}

			this.axios.get("/japi/check/report_handle/?tag=all&page=" +
					str +
					"&page_num=" +
					this.pageSize +
					"&item_uuid__type="+this.form.type+
					"&process="+this.form.process+
					"&item_uuid__checked_file_text__contains="+this.form.yw+
					"&title__contains="+this.form.title__contains+
					"&author_name__contains="+this.form.author_name__contains+
					"&create_time__gte="+startTime+
					"&create_time__lte="+endTime).then(res =>{
				if (res.data.code == 200) {
					console.log("审查报告管理表格数据======");
					console.log(res);
					this.total = res.data.data.sum;
					this.tableData = res.data.data.res;
					this.loading=false;//加载中隐藏
				} else if(res.data.code == 500){
					this.$message({
						message: res.data.msg,
						type: "warning",
						duration: 3000
					});
				}

			});
		},
		//审查类型
		typeDataFun(){
			this.axios.get("/japi/check/get_all_check_types/").then(res => {
				console.log("审查类型数据======");
				if (res.status == 200) {
					console.log(res);
					//将两个数组合并
					// res.data.data.map(value=>{
						this.typeOptions=this.typeOptions.concat(res.data.data)
					// })					
				} else {
					console.log("审查类型数据请求失败！");
				}
			})
		},
		//点击标题跳转审查报告页面
		titleFun(id){
			window.localStorage.removeItem("taskUuid");
			window.localStorage.setItem("report_id",id);
			window.localStorage.setItem("reviewStage","task");//审查进度
			//跳转审查报告页面
			this.$router.push({ path: "/recordReview/reviewReport"});
		}
    }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/mixin.scss"; //定义方法
@import "../../../assets/css/recordReviewDetail.scss";//智能审查详情页样式

</style>